"use strict";
angular.module('appMarketplace')
    .service('NavigationService', ['$http', '$window', 'UrlService', 'navigationStyle', 'dataAttributes',
        'NotificationService', 'CommonService', '$state',
        function ($http, $window, UrlService, navigationStyle, dataAttributes, NotificationService,
                  CommonService, $state) {
            var service = this;

            service.capitalize = function capitalize(line) {
                if (line) {
                    var firstLetter = line.charAt(0).toUpperCase();
                    line = firstLetter + (line.length > 1 ? line.slice(1) : '');
                }
                return line;
            };

            service.produceMenuGroup = function (group) {
                return {
                    id: group.id,
                    text: '<span id="menu-' + group.id + '" class="' + navigationStyle[group.name] + ' nav-group-icon" ' +
                            dataAttributes[group.name] + '></span>' + service.capitalize(group.name),
                    encoded: false,
                    cssClass: "nav-group"
                };
            };

            service.getNavigationDataSuccessCallback = function (response, successCallback) {
                var data = response.data;
                var navigationGroups = [];
                angular.forEach(data, function iterator(group) {
                    var menuGroupItem;
                    if (group.name === 'home') {
                        var homeItem = group.items[0];
                        menuGroupItem = service.produceMenuGroup(group);
                        menuGroupItem.url = UrlService.createAbsoluteUrl(homeItem.url);
                        navigationGroups.push(menuGroupItem);
                    } else {
                        var navigationItems = [];
                        angular.forEach(group.items, function iterator(item) {
                            var url = UrlService.createAbsoluteUrl(item.url);
                            navigationItems.push({
                                text: '<span id="subMenu-' + item.id + '"></span>' +
                                    service.capitalize(item.name),
                                url: url,
                                encoded: false
                            });
                        });
                        menuGroupItem = service.produceMenuGroup(group);
                        menuGroupItem.items = navigationItems;
                        navigationGroups.push(menuGroupItem);
                    }
                });
                successCallback(navigationGroups);
            };

            service.getNavigationData = function getNavigationData(successCallback) {
                var req = {
                    method: 'GET',
                    url: UrlService.createAbsoluteUrl('/rest/currentAccount/navigation')
                };
                $http(req)
                    .then(function successCallbackWrapper(response) {
                        service.getNavigationDataSuccessCallback(response, successCallback);
                    }, NotificationService.showValidationErrors);
            };

            service.fillMenuItems = function (menuItems, account) {
                angular.forEach(account.accountMenu, function (item) {
                    var itemUrl = item.url;
                    var url = null;
                    var select = null;
                    if (itemUrl === 'update-password.html') {
                        select = function onItemSelect() {
                            $state.go('update-password-state', {manualUpdate: true}, {location: false});
                        }
                    } else if (itemUrl === 'update-password-hint.html') {
                        select = function onItemSelect() {
                            $state.go('update-password-hint-state', {manualUpdate: true}, {location: false});
                        }
                    } else {
                        url = UrlService.createAbsoluteUrl(itemUrl);
                    }
                    menuItems.push({
                        text: service.capitalize(item.name),
                        url: url,
                        select: select,
                        encoded: false
                    });
                });
            };

            service.getUserAccountMenu = function getUserAccountOptions(account) {
                var accountsToSwitch;
                if (account.availableAccounts) {
                    accountsToSwitch = [];
                    angular.forEach(account.availableAccounts, function (account) {
                        accountsToSwitch.push({
                            text: account.name,
                            select: function switchAccount() {
                                $http.post(UrlService.createAbsoluteUrl('/rest/currentAccount/' + account.id + '/switch')).then(
                                    function successfulCallback() {
                                        $window.location.reload();
                                    },
                                    function errorCallback() {
                                        NotificationService.showErrorMessage("Cannot switch account to '" + account.name + "'");
                                    }
                                );
                            }
                        });
                    });
                }

                function closeOnSelect(e) {
                    e.sender.close();
                }

                var userAccountOptions = {
                    text: '<span id="useInfo" class="glyphicons glyphicons-user menu-action" title="User account menu"></span>',
                    encoded: false,
                    items: [
                        {
                            text: CommonService.escapeHtml(account.name) + '<br>' +
                                CommonService.escapeHtml(account.orgUnitName) + '<br>' +
                                CommonService.escapeHtml(account.environmentName),
                            encoded: false,
                            cssClass: 'user-name',
                            items: accountsToSwitch
                        }, {
                            text: '',
                            cssClass: 'k-separator'
                        }
                    ]
                };

                var menuItems = userAccountOptions.items;
                service.fillMenuItems(menuItems, account);

                return userAccountOptions;
            };

            service.getResolvedCurrentAccount = function getResolvedCurrentAccount(resolvedCallback, notResolvedCallback) {
                if (service.currentAccountPromise && service.currentAccountPromise.resolved) {
                    service.getCurrentAccount(function setAccount(data) {
                        resolvedCallback(data);
                    });
                } else {
                    notResolvedCallback();
                }
            };

            service.fillHelpMenuItems = function (menuItems, account) {
                angular.forEach(account.helpMenu, function (item) {
                    var itemUrl = item.url;
                    var url = null;
                    var attr = null;
                    if (itemUrl === 'about.html') {
                        attr = 'about'; // add it as angular attribute
                    } else {
                        url = UrlService.createAbsoluteUrl(itemUrl);
                    }

                    var attrs = {
                        openInNewWindow: UrlService.isAbsoluteUrl(itemUrl)
                    };
                    if (attr) {
                        attrs[attr] = attr;
                    }

                    menuItems.push({
                        spriteCssClass: determineFileTypeIcon(item.type),
                        text: service.capitalize(item.name),
                        url: url,
                        encoded: false,
                        attr: attrs
                    });
                });
            };

            service.getHelpMenu = function getHelpOptions(account) {
                var menu = {
                    text: '<span id="question" class="glyphicons glyphicons-question-sign menu-action" title="Help menu"></span>',
                    encoded: false,
                    items: []
                };

                service.fillHelpMenuItems(menu.items, account);
                return menu;
            };

            service.getQuickLinksMenuSuccessCallback = function (resultQuickLinks, response) {
                var quickLinks = response.data;
                if (quickLinks) {
                    angular.forEach(quickLinks, function iterator(value) {
                        var url = UrlService.createAbsoluteUrl(value.url);
                        resultQuickLinks.push({
                            text: service.capitalize(value.labelText),
                            url: url,
                            encoded: false
                        });
                    });
                }
            };

            service.getQuickLinksMenu = function () {
                var resultQuickLinks = [];
                var req = {
                    method: 'GET',
                    url: UrlService.createAbsoluteUrl('/rest/currentAccount/quickLinks')
                };

                $http(req).then(function successfulCallback(response) {
                        service.getQuickLinksMenuSuccessCallback(resultQuickLinks, response);
                    },
                    function errorCallback(response) {
                        NotificationService.showErrorMessage(response.data);
                    }
                );

                return {
                    text: '<span class="glyphicons glyphicons-pushpin menu-action" title="Quick links"></span>',
                    encoded: false,
                    items: resultQuickLinks
                };
            };

            service.getCurrentAccount = function getCurrentAccount(successCallback) {
                if (!service.currentAccountPromise) {
                    service.currentAccountPromise = $http.get(UrlService.createAbsoluteUrl('/rest/currentAccount'));
                }
                return service.currentAccountPromise
                    .then(function successCallbackWrapper(response) {
                        service.currentAccountPromise.resolved = true;
                        successCallback(response.data);
                    }, NotificationService.showValidationErrors);
            };

            service.updateBasketBadge = function (basketSize, netTotalValue) {
                service.getCurrentAccount(function callback(currentAccount) {
                    currentAccount.basketSize = basketSize;
                    currentAccount.basketNetTotal.value = netTotalValue;
                });
            };

            function determineFileTypeIcon(type) {
                switch (type) {
                    case 'application/pdf':
                        return 'far fa-file-pdf';
                    default:
                        return null;
                }
            }
        }]);



//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/services/navigation-service.js
// module id = 272
// module chunks = 17